import { html  } from 'lit';
import IVPLitElementBase from './lit-element-base.js';

export default class DlgProgress extends IVPLitElementBase {

	static get tag() { return "progress-dialog" }

    static get properties() {
        return {
            percent: { type: Number },
            title:  { type: String },
            text:  { type: String },
        };
    }

    constructor() {
        super();
        this.percent = 0
        this.title = "Title"
        this.text = "Text"
    }

    render() {
        return html`
        <!-- Modal -->
        <div class="modal fade" id="progress_dialog" tabindex="-1" role="dialog" style="display: none;" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" >${this.title}</h5>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-xl-12">
                                <div class="card">
                                    <div class="card-body">
                
                                        <p class="card-subtitle mb-4">${this.text}</p>
                
                                        <div class="progress">
                                            <div class="progress-bar progress-bar-striped progress-bar-animated " role="progressbar" 
                                                aria-valuenow="${this.percent}" aria-valuemin="0" aria-valuemax="100">${this.percent}%</div>
                                        </div>
                                    </div> <!-- end card-body-->
                                </div> <!-- end card-->
                            </div> <!-- end col -->
                        </div> 
                    </div>
                </div>
            </div>
        </div>
        `
    }

    
    firstUpdated(changedProps) {
        $('#progress_dialog').modal({backdrop:'static',keyboard:false})
    }

    updated() {
        this.querySelector(".progress-bar").style.width = `${this.percent}%`
    }

    static Show(title,text) {

        let el = new DlgProgress()
        el.title = title
        el.text = text

        el.promise = new Promise((resolve) => {
            el.promise_resolve = resolve
        })
        
        let vels = document.querySelectorAll("progress-dialog")
		if (vels != null)
			vels.forEach((el)=>{ el.remove() })

        document.body.append(el)
        return el
    }

    Remove() {
        this.promise_resolve()

        $('#progress_dialog').modal('hide')
        this.remove()
        // $('.modal-backdrop').remove();
        // document.body.classList.remove('modal-open')
    }    
}
DlgProgress.RegisterElement()